function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.41,422.36c-6.77,11-41.12,16.21-59.87,15.72s-72.7-26-76.36-31.44c-3.39-5-11.72-21.57,1.12-31.58a24.88,24.88,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,7,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76a13.88,13.88,0,0,1,3.06,2.22C401.24,399.08,408.17,411.33,401.41,422.36Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.16,431.92l17.52,13.75a200.72,200.72,0,0,0,25.12-3.76h0c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09-1.36,0-2.76.14-4.17.28-11.67,1.25-26.51-5.19-26.51-5.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.49,437.34c-3.16.51.31,7,4.59,5S351.65,436.82,348.49,437.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.8,441.9c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09C377.6,426.67,370.53,433.5,374.8,441.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.39,432.45l-18.86,11.83a201.2,201.2,0,0,1-24.59-6.37h0c-8.05-2.78-15-6.28-15-10.08,0-5.78,6.27-6.69,13.5-5.71,1.35.18,2.73.43,4.12.72,11.47,2.47,26.9-2.38,26.9-2.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,431.66H280.19c.85-1.36,1.71-2.72,2.59-4.05,22.72-34.58,59.1-59.24,98.83-70.81,17.8-5.18,37.08-8.26,51.38-20.06,14.72-12.13,21.48-31.49,24.4-50.34,3.55-22.82,1.63-48.41-13.86-65.54-18.19-20.11-48.67-22.37-72.37-35.55-40.79-22.7-56.6-74.39-93.71-102.71C254,64.71,222.36,57.78,194,61.7c-40.19,5.57-78,32.5-89.35,72a99.64,99.64,0,0,0-3.44,35.42c1.81,23.55,6.88,47.4,2.1,70.53-5.27,25.49-21.85,47-31.76,71.09-12.34,30-14,63.6-8.77,95.58A164.67,164.67,0,0,0,69,431.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,431.66H280.19c.85-1.36,1.71-2.72,2.59-4.05,22.72-34.58,59.1-59.24,98.83-70.81,17.8-5.18,37.08-8.26,51.38-20.06,14.72-12.13,21.48-31.49,24.4-50.34,3.55-22.82,1.63-48.41-13.86-65.54-18.19-20.11-48.67-22.37-72.37-35.55-40.79-22.7-56.6-74.39-93.71-102.71C254,64.71,222.36,57.78,194,61.7c-40.19,5.57-78,32.5-89.35,72a99.64,99.64,0,0,0-3.44,35.42c1.81,23.55,6.88,47.4,2.1,70.53-5.27,25.49-21.85,47-31.76,71.09-12.34,30-14,63.6-8.77,95.58A164.67,164.67,0,0,0,69,431.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-59"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 41.99,
    y1: 431.66,
    x2: 460.31,
    y2: 431.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,113.39V97.69l-11.76-1a32.58,32.58,0,0,0-2.9-7.05l7.59-9-11.1-11.1-9,7.59a32,32,0,0,0-7-2.91l-1-11.76H228l-1,11.76a32,32,0,0,0-7,2.91l-9-7.59-11.1,11.1,7.59,9a32.58,32.58,0,0,0-2.9,7.05l-11.76,1v15.7l11.76,1a32.58,32.58,0,0,0,2.9,7l-7.59,9,11.1,11.1,9-7.59a32,32,0,0,0,7,2.91l1,11.76H243.7l1-11.76a32.31,32.31,0,0,0,7.05-2.91l9,7.59,11.1-11.1-7.59-9a32.58,32.58,0,0,0,2.9-7Zm-43.1,10.39a18.24,18.24,0,1,1,18.24-18.24A18.25,18.25,0,0,1,235.86,123.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.69,266.84v-7.52l-5.64-.49a15.92,15.92,0,0,0-1.39-3.38l3.64-4.33L439,245.8l-4.32,3.64a15.41,15.41,0,0,0-3.38-1.39l-.49-5.64h-7.53l-.48,5.64a15.21,15.21,0,0,0-3.38,1.39l-4.33-3.64-5.32,5.32,3.64,4.33a15.44,15.44,0,0,0-1.4,3.38l-5.64.49v7.52l5.64.49a15.44,15.44,0,0,0,1.4,3.38L409.74,275l5.32,5.32,4.33-3.64a15.21,15.21,0,0,0,3.38,1.39l.48,5.64h7.53l.49-5.64a15.41,15.41,0,0,0,3.38-1.39l4.32,3.64L444.3,275l-3.64-4.33a15.92,15.92,0,0,0,1.39-3.38Zm-20.67,5a8.75,8.75,0,1,1,8.74-8.75A8.75,8.75,0,0,1,427,271.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,129.8a20.53,20.53,0,0,0-25.36-24.44,19.7,19.7,0,0,0-36.82,8.43,16.08,16.08,0,0,0-19,14,9,9,0,0,0,.2,17.92h75.28A9,9,0,0,0,442,129.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.63,
    y1: 138.83,
    x2: 400.63,
    y2: 159.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.63,
    y1: 126.39,
    x2: 400.63,
    y2: 134.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.63,
    y1: 118.63,
    x2: 400.63,
    y2: 123.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "396.71 157.16 400.63 162.01 404.55 157.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,373.15a20.54,20.54,0,0,0-25.37-24.44,19.69,19.69,0,0,0-36.81,8.44,16.27,16.27,0,0,0-3-.29,16.09,16.09,0,0,0-16,14.28,9,9,0,0,0,.19,17.92H207a9,9,0,0,0,5.67-15.91Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.24,
    y1: 385.15,
    x2: 171.24,
    y2: 364.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.24,
    y1: 397.6,
    x2: 171.24,
    y2: 389.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.24,
    y1: 405.36,
    x2: 171.24,
    y2: 400.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "175.16 366.83 171.24 361.98 167.32 366.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.48,109.9H304.93a4.24,4.24,0,0,1,4.24,4.24V126a0,0,0,0,1,0,0H49.24a0,0,0,0,1,0,0V114.14A4.24,4.24,0,0,1,53.48,109.9Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.62,
    y: 128.97,
    width: 262.71,
    height: 184.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,117.94a4,4,0,1,1-4-4A4,4,0,0,1,327.35,117.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,117.94a4,4,0,1,1-4-4A4,4,0,0,1,313.19,117.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,117.94a4,4,0,1,1-4-4A4,4,0,0,1,299,117.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.37,
    y1: 136.9,
    x2: 304.97,
    y2: 136.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.37,
    y1: 141.12,
    x2: 304.97,
    y2: 141.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.37,
    y1: 145.34,
    x2: 304.97,
    y2: 145.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.81,
    y1: 245.98,
    x2: 157.54,
    y2: 245.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.81,
    y1: 252.19,
    x2: 157.54,
    y2: 252.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.81,
    y1: 258.51,
    x2: 140.89,
    y2: 258.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.76,
    y1: 131.05,
    x2: 245.76,
    y2: 131.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.76,
    y1: 134.55,
    x2: 245.76,
    y2: 308.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.998449981212616,2.995349884033203"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.76,
    y1: 310.28,
    x2: 245.76,
    y2: 310.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.78,
    y1: 272.38,
    x2: 64.28,
    y2: 272.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.27,
    y1: 272.38,
    x2: 317.31,
    y2: 272.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.9981380105018616,2.9944100379943848"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.81,
    y1: 272.38,
    x2: 319.31,
    y2: 272.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.04,
    y: 270.65,
    width: 3.45,
    height: 3.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.99,
    y1: 239.24,
    x2: 185.93,
    y2: 239.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,260.54s0-21.41-23.92-21.41S185,260.54,185,260.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.88,
    cy: 260.54,
    r: 2.02,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,260.54a2,2,0,1,1,2,2A2,2,0,0,1,183,260.54Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.11,
    y: 237.36,
    width: 3.54,
    height: 3.54,
    transform: "translate(465.76 478.26) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.19,
    y: 237.36,
    width: 3.54,
    height: 3.54,
    transform: "translate(417.92 478.26) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.27,
    y: 237.36,
    width: 3.54,
    height: 3.54,
    transform: "translate(370.08 478.26) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,174.87v-7.08l-5.29-.45a15.09,15.09,0,0,0-1.31-3.18l3.42-4.06-5-5-4.07,3.42A14.22,14.22,0,0,0,92,157.21l-.46-5.3H84.48l-.46,5.3a14,14,0,0,0-3.17,1.31l-4.07-3.42-5,5,3.42,4.06a14.58,14.58,0,0,0-1.31,3.18l-5.3.45v7.08l5.3.45a14.78,14.78,0,0,0,1.31,3.18l-3.42,4.06,5,5,4.07-3.42A14,14,0,0,0,84,185.45l.46,5.3h7.07l.46-5.3a14.22,14.22,0,0,0,3.17-1.31l4.07,3.42,5-5-3.42-4.06a15.31,15.31,0,0,0,1.31-3.18ZM88,179.55a8.22,8.22,0,1,1,8.22-8.22A8.22,8.22,0,0,1,88,179.55Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,190.73v-4.84l-3.63-.32a9.81,9.81,0,0,0-.89-2.17l2.34-2.78-3.43-3.42-2.78,2.34a10.34,10.34,0,0,0-2.17-.9L120.6,175h-4.84l-.32,3.63a10.34,10.34,0,0,0-2.17.9l-2.78-2.34-3.43,3.42,2.35,2.78a9.38,9.38,0,0,0-.9,2.17l-3.63.32v4.84l3.63.31a9.2,9.2,0,0,0,.9,2.17L107.06,196l3.43,3.42,2.78-2.34a10.34,10.34,0,0,0,2.17.9l.32,3.62h4.84l.31-3.62a10.34,10.34,0,0,0,2.17-.9l2.78,2.34,3.43-3.42L127,193.21a9.61,9.61,0,0,0,.89-2.17Zm-13.29,3.2a5.63,5.63,0,1,1,5.62-5.62A5.63,5.63,0,0,1,118.18,193.93Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.64,
    y1: 284.14,
    x2: 294.37,
    y2: 284.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.64,
    y1: 290.35,
    x2: 294.37,
    y2: 290.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.64,
    y1: 296.67,
    x2: 277.72,
    y2: 296.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,299.25H184.22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h20.39a5,5,0,0,1,5,5h0A5,5,0,0,1,204.61,299.25Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,299.25H222.22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h20.39a5,5,0,0,1,5,5h0A5,5,0,0,1,242.61,299.25Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.47,
    y: 191.97,
    width: 43.24,
    height: 43.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.47,
    y1: 191.97,
    x2: 301.71,
    y2: 235.21,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.71,
    y1: 191.97,
    x2: 258.47,
    y2: 235.21,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.43 142.88 275.43 152.97 270.98 157.42 260.89 157.42 260.89 142.88 275.43 142.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.43 152.97 270.98 157.42 270.98 152.97 275.43 152.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.8 220.91 120.8 231 116.35 235.46 106.26 235.46 106.26 220.91 120.8 220.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.8 231 116.35 235.46 116.35 231 120.8 231",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.86 283.08 65.86 293.17 61.41 297.62 51.31 297.62 51.31 283.08 65.86 283.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.86 293.17 61.41 297.62 61.41 293.17 65.86 293.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.01,
    y: 166.28,
    width: 53.66,
    height: 33.63,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.01,
    y: 166.28,
    width: 53.66,
    height: 5.11,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.48,
    y1: 175.7,
    x2: 314.2,
    y2: 175.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.34,
    y1: 179.53,
    x2: 331.08,
    y2: 179.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.31,
    y1: 183.1,
    x2: 311.3,
    y2: 183.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.34,
    y1: 187.31,
    x2: 323.33,
    y2: 187.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.48,
    y1: 191.13,
    x2: 314.2,
    y2: 191.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 301.59,
    width: 53.66,
    height: 33.63,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 301.59,
    width: 53.66,
    height: 5.11,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.68,
    y1: 311.02,
    x2: 112.39,
    y2: 311.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.53,
    y1: 314.84,
    x2: 129.27,
    y2: 314.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.5,
    y1: 318.41,
    x2: 109.49,
    y2: 318.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.53,
    y1: 322.62,
    x2: 121.52,
    y2: 322.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.68,
    y1: 326.45,
    x2: 112.39,
    y2: 326.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167,58h-49.3a2.19,2.19,0,0,0-2.18,2.18v23a2.18,2.18,0,0,0,2.18,2.17H139.8l2.52,9,2.53-9H167a2.18,2.18,0,0,0,2.18-2.17v-23A2.19,2.19,0,0,0,167,58Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.7,
    y1: 64.58,
    x2: 160.95,
    y2: 64.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.7,
    y1: 69.3,
    x2: 160.95,
    y2: 69.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.7,
    y1: 74.02,
    x2: 160.95,
    y2: 74.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.7,
    y1: 78.74,
    x2: 151.77,
    y2: 78.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.87,221.58c-5.29.45-12-5.87-12-5.87a1.19,1.19,0,0,1-1.89-.24c-.86-1.24-4.59-4.11-4.8-6.59s4.19-6.5,4.19-6.5c-3.39.92-3.75-1.07-3.75-1.07s5.71-4.71,7.71-4.84c.78-.05,4.18,1.91,7.47,4.55,3.44,2.77,9.9,12.52,9.9,12.52s21.85,15.87,27.37,19.93c7.29,5.36,15.93,14.87,15.93,14.87s29,13.08,37,20.27l-10.82,25.62s-26.37-17.67-29-22.15-5.27-1.79-7.91-4.72-5.17-6.28-5.17-6.28A44.58,44.58,0,0,1,269.51,252c-6.16-6.33-11.59-16-15-21.82A36,36,0,0,0,247.87,221.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,217.84s-7.87-1.91-8.55-7.1a9.55,9.55,0,0,0-1.69-3.63s-7.34-.36-6.88-3.35l9.8-.87a17.06,17.06,0,0,1,8.53,7.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,215.71a3.22,3.22,0,0,0,.33-2.12s2.16-.4,1.92-2.31c0,0,3.2-.39,1.13-4.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.11,211.28s-4.31-3.19-4.79-4.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,213.59s-4.59-2.8-4.67-4.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.24,199.21s-1.46,2.62-3.88,3.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.51,200.23a12.55,12.55,0,0,1,2.16,1.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.12,288.8a236.19,236.19,0,0,0-34.91-11.66c-17.56-4.11-46-7.78-46-7.78s7.82,79.8,5.76,84.6-14.42,20.92-14.42,20.92,66.89,26.08,78.55,28.3,5.58-38.25,5.58-38.25S411,313.49,404.12,288.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.11,280.23s1.59,3-2.59,4.57c-10.83,4-22.37.47-21.14-3.77.47-1.62,3.15,0,3-6a7.37,7.37,0,0,0-.73-2.66,27.47,27.47,0,0,0-2.75-4.61,57.26,57.26,0,0,0-3.71-4.63s17.19-11,29.94,0C382.11,263.08,377.37,265.48,380.11,280.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.41,422.36c-6.77,11-41.12,16.21-59.87,15.72s-72.7-26-76.36-31.44c-3.39-5-11.72-21.57,1.12-31.58a24.88,24.88,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,7,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76a13.88,13.88,0,0,1,3.06,2.22C401.24,399.08,408.17,411.33,401.41,422.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-59)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.78,387.88c-10.31-.69-19.5,1.47-25.92,5.26-7.61,4.5-43.55,21.81-43.55,21.81.08-1.86,2.08-5.61,2.08-5.61-3.38-3-12.22-5.35-12.22-5.35-6.85-5.85-34-23.3-42.87-28.93a24.88,24.88,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,7,3.82,15.24,6.17C363,388.77,378.72,382.43,388.78,387.88Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.41,422.36c-6.77,11-41.12,16.21-59.87,15.72s-72.7-26-76.36-31.44c-3.39-5-11.72-21.57,1.12-31.58a24.88,24.88,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,7,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76a13.88,13.88,0,0,1,3.06,2.22C401.24,399.08,408.17,411.33,401.41,422.36Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,432.32l.86,3.77s-2.3,6.52-12.41,7.59-16.1,3.3-21,3.59a40.82,40.82,0,0,1-7.69-.12l-1-1.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.16,431.92l17.52,13.75a200.72,200.72,0,0,0,25.12-3.76h0c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09-1.36,0-2.76.14-4.17.28-11.67,1.25-26.51-5.19-26.51-5.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-59)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.75,433.32a53.46,53.46,0,0,0-9.74,4.8s-16.27,8.37-41.28-.25l-7.57-5.95,15.08-10.47s14.83,6.45,26.51,5.19c1.41-.15,2.81-.25,4.17-.28C385.16,426.14,391.25,427.68,390.75,433.32Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.16,431.92l17.52,13.75a200.72,200.72,0,0,0,25.12-3.76h0c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09-1.36,0-2.76.14-4.17.28-11.67,1.25-26.51-5.19-26.51-5.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,437.34c-3.16.51.31,7,4.59,5S351.65,436.82,348.49,437.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-59)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.42,441.31a66.94,66.94,0,0,1-6.81-1.19c-.6-1.27-.46-2.57.88-2.78C351.14,436.9,355.6,439.35,354.42,441.31Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,437.34c-3.16.51.31,7,4.59,5S351.65,436.82,348.49,437.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,441.9c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09C377.6,426.67,370.53,433.5,374.8,441.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-59)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.75,433.32a53.46,53.46,0,0,0-9.74,4.8,32.78,32.78,0,0,1-6.85,2.29c-2.8-7.7,3.46-13.76,3.76-14.05C385.16,426.14,391.25,427.68,390.75,433.32Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,441.9c8.3-1.92,15.55-4.67,15.94-8.45.61-5.74-5.53-7.31-12.82-7.09C377.6,426.67,370.53,433.5,374.8,441.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,434.77h.05a.86.86,0,0,0,.9-.83,11.78,11.78,0,0,1,3-6.59.86.86,0,0,0,0-1.22.87.87,0,0,0-1.22,0,13.36,13.36,0,0,0-3.47,7.71A.86.86,0,0,0,368.88,434.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,435h.07a.86.86,0,0,0,.88-.85,12.84,12.84,0,0,1,2.66-6.86.87.87,0,1,0-1.34-1.1,14.48,14.48,0,0,0-3.05,7.92A.86.86,0,0,0,365.41,435Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.26,434.54h0a.86.86,0,0,0,.94-.78c.27-3,2.85-6.93,2.88-7a.88.88,0,0,0-.24-1.21.87.87,0,0,0-1.2.24c-.12.17-2.86,4.29-3.17,7.77A.87.87,0,0,0,361.26,434.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34,434.13a.91.91,0,0,0,.23,0,.86.86,0,0,0,.71-1c-.61-3.68,2.81-6.83,2.84-6.86A.87.87,0,0,0,360,425c-.17.15-4.16,3.81-3.39,8.44A.88.88,0,0,0,357.34,434.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,433.1a.88.88,0,0,0,.28,0,.87.87,0,0,0,.65-1c-.75-3.28,2.48-7,2.52-7a.87.87,0,0,0-.08-1.22.86.86,0,0,0-1.22.07c-.16.18-3.86,4.41-2.91,8.57A.86.86,0,0,0,353.08,433.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,426.68l-1.25,3.66s1.6,6.73,11.54,8.85,15.66,5,20.46,5.78a41.19,41.19,0,0,0,7.66.68l1.15-1.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.39,432.45l-18.86,11.83a201.2,201.2,0,0,1-24.59-6.37h0c-8.05-2.78-15-6.28-15-10.08,0-5.78,6.27-6.69,13.5-5.71,1.35.18,2.73.43,4.12.72,11.47,2.47,26.9-2.38,26.9-2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-59)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.39,432.45l-11.09,7a44.86,44.86,0,0,1-22.54-15.87,75.09,75.09,0,0,0,19.73-3.09Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.39,432.45l-18.86,11.83a201.2,201.2,0,0,1-24.59-6.37h0c-8.05-2.78-15-6.28-15-10.08,0-5.78,6.27-6.69,13.5-5.71,1.35.18,2.73.43,4.12.72,11.47,2.47,26.9-2.38,26.9-2.38Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.94,437.9c-8.05-2.78-15-6.28-15-10.08,0-5.78,6.27-6.69,13.5-5.71C276.76,422.45,283.07,430,277.94,437.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,431.43h-.05a.88.88,0,0,1-.82-.92,11.73,11.73,0,0,0-2.27-6.86.87.87,0,1,1,1.36-1.07,13.27,13.27,0,0,1,2.64,8A.86.86,0,0,1,284.58,431.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,432h-.08a.87.87,0,0,1-.79-.94,12.77,12.77,0,0,0-1.91-7.09.87.87,0,1,1,1.44-1,14.33,14.33,0,0,1,2.2,8.2A.87.87,0,0,1,288,432Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,432h0a.88.88,0,0,1-.86-.88c.06-3.05-2.1-7.18-2.13-7.22a.88.88,0,0,1,.37-1.18.87.87,0,0,1,1.17.37c.1.18,2.39,4.56,2.33,8.06A.87.87,0,0,1,292.18,432Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.12,432l-.23,0a.87.87,0,0,1-.6-1.07c1-3.59-2.07-7.09-2.1-7.12a.87.87,0,1,1,1.29-1.16c.15.17,3.74,4.23,2.48,8.75A.88.88,0,0,1,296.12,432Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,431.43a.66.66,0,0,1-.28-.05.85.85,0,0,1-.54-1.1c1.09-3.18-1.74-7.21-1.76-7.25a.87.87,0,1,1,1.41-1c.14.19,3.37,4.79,2,8.83A.88.88,0,0,1,300.47,431.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,436.12c3.09.85-1,6.9-5.09,4.5S301.5,435.28,304.58,436.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.92,404c4.63,6.49,18.36,13.66,32,19.57a64.23,64.23,0,0,0,8.58,11.21c8.42,8.66,11.85,3.81,11.85,3.81s5.32-.6,13.17-1.67a3.75,3.75,0,0,0,4,2.23c1-.16,3-1.62,5.21-3.55,19.83-3,46.74-8,54-13.82",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,391.64c-3.43-3.77-6.86-3.94-14.06-3.43,0,0-18.79,6-31.9,13.89s-32.23,16.26-32.23,16.26-5.83-1.69-9.89,0c0,0-2.85.22-.94,5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.72,414.17s.1,5.81-8.14,9.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84,389.93s13,9.4,15.61,15.6a53.53,53.53,0,0,1,7.38,3.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39,397.74a15,15,0,0,1,.46,8.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.39,391.64a22.74,22.74,0,0,1,1.86,3.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91,390.78s4.35,5.82,5.43,10.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,425.94a37.33,37.33,0,0,0,4.82-.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,421.77a231.67,231.67,0,0,0,37.39,4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.32,333.59s-2.35,41-5.12,43.35-7.14,3.08-15.41,3.77-44.85,2.93-44.85,2.93L342,371.89s19.45-2,28.08-5.15A144.73,144.73,0,0,1,390,361.48s-1.64-10.31-1.64-14.75V325.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.12,288.8c8.91,5.49,11.54,18.18,8.46,45.27,0,0,2.63,3.2-1.26,4.8,0,0-14.57-5.45-21.34-1.69s-5-5.19-5-5.19-2.79-24.92,3.38-29.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.54,298.75s-8.57,8.91-1,31.43a36.74,36.74,0,0,0-1,5.6c0,1.51,2.07,2.29,2.07,2.29",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.52,313.84s.62,11,7.44,15.77",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.72,288.3s-13.29,5.09-23.86-.55c-6.27-3.34-3.69-8.71-3.69-8.71",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,391.66h72.34a18.85,18.85,0,0,0,4.84-.63l14.27-3.74a.92.92,0,0,0,.69-.89h0a.93.93,0,0,0-.93-.93h-94.2a.93.93,0,0,0-.92.93v1.35A3.91,3.91,0,0,0,284.15,391.66Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,388.06h72.54a1.72,1.72,0,0,0,1.69-2.32l-13.45-52.33a3.2,3.2,0,0,0-2.9-2.33H262.32a1.73,1.73,0,0,0-1.69,2.33l13.46,52.33A3.18,3.18,0,0,0,277,388.06Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.88,
    y1: 332.94,
    x2: 263.51,
    y2: 332.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.51,
    y1: 332.94,
    x2: 268.43,
    y2: 332.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,381.45,335.9,335.27a3.19,3.19,0,0,0-2.89-2.33h-55.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.81,
    y1: 385.47,
    x2: 348.51,
    y2: 384.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,360.89a7.14,7.14,0,0,0,.26,1.25c.92,3.15,3.87,5.07,6.58,4.27s4.16-4,3.24-7.15-3.89-5.07-6.6-4.27a4.62,4.62,0,0,0-.91.39A5.59,5.59,0,0,1,298.81,360.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.83,262.82c-6.28-.68-9.7-6.65-13.48-7.58a41.65,41.65,0,0,1-6.18-2s-1.3-4.54-3.25-3-4.51,35.5-2,34.43,2.52,2.94,2.52,2.94l23.31,20.54,19.54-34.6S337.11,263.51,330.83,262.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.88 141.89 140.88 141.39 141.38 141.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.32,
    y1: 141.39,
    x2: 228.92,
    y2: 141.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.9780219793319702,2.934070110321045"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "230.38 141.39 230.88 141.39 230.88 141.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.89,
    y1: 144.89,
    x2: 230.89,
    y2: 199.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1,3"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "230.88 200.89 230.88 201.39 230.38 201.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.45,
    y1: 201.39,
    x2: 142.85,
    y2: 201.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.9780219793319702,2.934070110321045"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.38 201.39 140.88 201.39 140.88 200.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.89,
    y1: 197.89,
    x2: 140.89,
    y2: 143.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1,3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.89,
    cy: 141.39,
    r: 1.48,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.89,
    cy: 171.39,
    r: 1.48,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.89,
    cy: 201.39,
    r: 1.48,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.89,
    cy: 171.39,
    r: 1.48,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.16,
    y: 199.67,
    width: 3.45,
    height: 3.45,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.16,
    y: 139.67,
    width: 3.45,
    height: 3.45,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.16,
    y: 199.67,
    width: 3.45,
    height: 3.45,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.16,
    y: 139.67,
    width: 3.45,
    height: 3.45,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 146.7,
    width: 78.33,
    height: 49.77,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.19 181.77 216.48 190.48 192.92 166.92 183.01 176.83 167.21 161.03 146.86 181.37 146.86 196.47 225.19 196.47 225.19 181.77",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.96,
    cy: 160.83,
    r: 5.53,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,272s-6,11.17-6.71,28.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,279.73s1.79,9.5,7,16.38",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,318.93s9,29.56,28.55,38.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.68,265.42s-.85,6.45-7.05,6.9a27.47,27.47,0,0,0-2.75-4.61A86.58,86.58,0,0,1,365.68,265.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,265.87s10.37,1.27,14.71-12.65.93-24.41-16.23-29.46c-9.52-2.8-19-.55-22.47,6.66-2.94,6.17-1.55,11.3-2.22,13.37-.76,2.32-7.78,4.29-7.78,5.88,0,1.31,3.89,3.55,3.89,3.55l-1.14,3.46,1.07.57s-2,7.79-1.07,10.54c.66,2,18.23,2.84,19.6-2.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,235.47s3.43.86,4.37,2.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.6,243.38c-.15,1,.08,1.87.52,1.93s.9-.7,1.05-1.71-.09-1.87-.52-1.93S355.75,242.37,355.6,243.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,257.25s5.58,2.14,7.66.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,242.58c-.41,2.24.09,4.2,1.12,4.39s2.21-1.46,2.62-3.69-.08-4.21-1.12-4.4S351.1,240.35,350.68,242.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.06,231.19a16.5,16.5,0,0,0-6.52-10.06A30.51,30.51,0,0,0,375,216s3.31,1.45,4.57,3.36c0,0-8.57-6.44-18.75-2.21s-8.91,15.22-8.91,15.22l1.48-2.88s-.17,3.43,1.63,4.69a22.52,22.52,0,0,1,2.19-4.8s2.7,8.11,10.13,10.86a5.9,5.9,0,0,1-.12-4s4.12,8.91,2.92,13.26l1.31,2.28s4.73-4.79,8.58-.8c2.21,2.3-4.23,11-5.15,11l3.89,5.71s9.72,1.39,15.32-9.14,4.23-15,4.23-15,1.83,2.56,2,4C400.34,247.53,402,236.22,394.06,231.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,252.79s3-10.08,9.38-6.53,1.83,8.93-.46,11-4,5.83-5.49,5.83-1.82-1.83-1.82-1.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.42,
    y1: 243.28,
    x2: 372.22,
    y2: 246.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg-1.92cadc45efa03798786cee890ce4e888.svg";
export { ForwardRef as ReactComponent };